import { render, staticRenderFns } from "./Home_b.vue?vue&type=template&id=1d2ecd70&scoped=true&lang=pug&"
import script from "./Home_b.vue?vue&type=script&lang=ts&"
export * from "./Home_b.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ecd70",
  null
  
)

export default component.exports